import { useScheduleActionsContextValue } from '../../EventsPanel/ScheduleActions/ScheduleRequests/hooks/use-schedule-actions-context-value';
import { ScheduleActionsContext } from './ScheduleActionsContext';

export const ScheduleActionsProvider = ({
  children,
  closeModal,
}: React.PropsWithChildren<{ closeModal?: () => void }>) => {
  const providerValue = useScheduleActionsContextValue({ closeModal });

  return <ScheduleActionsContext.Provider value={providerValue}>{children}</ScheduleActionsContext.Provider>;
};
